import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ellipsesMultipleLines, Link } from '@codex/basics';

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  padding-left: 40px;
  box-sizing: border-box;
`;

const Image = styled.img`
  width: 33px;
  height: 34px;
  margin-right: 13px;
`;

const Content = styled.div`
  line-height: 1.4;
`;

const Title = styled.div`
  ${ellipsesMultipleLines(1)};
`;

const MoreItems = styled.div``;

const NotificationLink = styled(Link)`
  margin: 15px 0;
  display: block;
  &:first-child {
    margin-top: 4px;
  }
  &:last-child {
    margin-bottom: 11px;
  }

  &${Link} {
    text-decoration: none
  }

  :hover {
    ${Title}, ${MoreItems} {
      text-decoration: underline;
    }
  }
`;

const OrderStatus = styled.div`
  font-weight: bold;
  color: ${props => (props.isPositiveOrderPath
    ? props.theme.colors.positive.default : props.theme.colors.error.default)};

`;

const OrderStatusOval = styled.span`
  background-color: ${props => (props.isPositiveOrderPath
    ? props.theme.colors.positive.default : props.theme.colors.error.default)};
  display: inline-block;
  width: 13px;
  height: 13px;
  border-radius: 14px;
  margin-right: 5px;
  margin-bottom: -2px;
  color: ${props => props.theme.colors.price.default};
`;

const StatusChangeNotification = props => (
  <NotificationLink
    href={props.orderUrl}
    data-track="status change:delete"
  >
    <Wrapper>
      <Image
        src={props.productImageUrl}
        alt={props.productLabel}
      />
      <Content>
        <Title>{props.productLabel}</Title>
        { props.orderItemsCount > 1 && <MoreItems>& other items</MoreItems> }

        <OrderStatus isPositiveOrderPath={props.isPositiveOrderPath}>
          <OrderStatusOval isPositiveOrderPath={props.isPositiveOrderPath} />
          {props.isPositiveOrderPath ? props.orderStatusLabel : 'Order amended'}
        </OrderStatus>
      </Content>
    </Wrapper>
  </NotificationLink>
);

StatusChangeNotification.propTypes = {
  orderId: PropTypes.number,
  productLabel: PropTypes.string,
  productImageUrl: PropTypes.string,
  orderStatusLabel: PropTypes.string,
  orderUrl: PropTypes.string,
  orderItemsCount: PropTypes.number,
  isPositiveOrderPath: PropTypes.bool
};

StatusChangeNotification.defaultProps = {
  orderId: undefined,
  productLabel: undefined,
  productImageUrl: undefined,
  orderStatusLabel: undefined,
  orderUrl: undefined,
  orderItemsCount: undefined,
  isPositiveOrderPath: true
};

export default StatusChangeNotification;
